import { createFileRoute } from "@tanstack/react-router";

import { inputsFromSearch } from "../../../workspaces/reports/inputs";
import { ReportPage } from "../../../workspaces/reports/pages/ReportPage";
import { searchWithView, splitViewSearch } from "../../../workspaces/reports/view";

/* The address's search is the report's inputs: `?robot=piper` runs the robot report about
 * Piper. Every value is kept as the router parsed it and read as text by the page, but
 * `view`, which is how the page shows its drawings: `?view=table` shows every one as its
 * table. */
export const Route = createFileRoute("/_console/p/$org/$project/reports/$name/")({
  validateSearch: (search: Record<string, unknown>): Record<string, unknown> => search,
  component: ReportRoute,
});

function ReportRoute() {
  const { name } = Route.useParams();
  const { view, rest } = splitViewSearch(Route.useSearch());
  const navigate = Route.useNavigate();
  const inputs = inputsFromSearch(rest);
  return (
    <ReportPage
      name={name}
      inputs={inputs}
      onInputs={(next) => void navigate({ search: searchWithView(next, view), replace: true })}
      view={view}
      onView={(next) => void navigate({ search: searchWithView(inputs, next), replace: true })}
    />
  );
}
